// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {SeqId} from './seq-id.js'

export class RemoveChars {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): RemoveChars {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsRemoveChars(bb: flatbuffers.ByteBuffer, obj?: RemoveChars): RemoveChars {
    return (obj || new RemoveChars()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsRemoveChars(bb: flatbuffers.ByteBuffer, obj?: RemoveChars): RemoveChars {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new RemoveChars()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  locations(index: number, obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 12, this.bb!) : null
  }

  locationsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  textField(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startRemoveChars(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addLocations(builder: flatbuffers.Builder, locationsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, locationsOffset, 0)
  }

  static startLocationsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(12, numElems, 4)
  }

  static addTextField(builder: flatbuffers.Builder, textFieldOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, textFieldOffset, 0)
  }

  static endRemoveChars(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // locations
    return offset
  }
}
